module.exports = __webpack_public_path__ + "static/media/closeWhite.6da8e61e.svg";